import PayerData from '../../models/payer_data';

export function getValue(property, defaultVal) {
  if (typeof property === 'undefined'){
    return defaultVal;
  }
  return property;
}
export function valueEquals(property, equals) {
  if (typeof property === 'undefined'){
    return false;
  }
  return property === equals;
}

export function mapInvoiceToPaymentDocument(invoice, details, payment_reason_codes) {
  let reason_description = "";
  if(details.reason !== "" && typeof details.reason !== "undefined"){
    reason_description = payment_reason_codes.find(r => r.reason_code === details.reason).description;
  }
  
  return {
    billing_document_number: invoice.billing_document_number,
    document_number_finance: invoice.document_number_finance,
    line_item_in_the_relevant_invoice: invoice.line_item_in_the_relevant_invoice,
    fiscal_year_of_the_relevant_invoice: invoice.fiscal_year_of_the_relevant_invoice,
    open_amount: invoice.open_amount,
    amount_to_process: details.amount,
    currency_key: invoice.currency_key,
    reason_code: details.reason,
    reason_description: reason_description,
    comment: details.comment,
    reference_number: invoice.reference_number,
    zzcustom: invoice.zzcustom
  }
}

export function mapInvoiceListToPaymentDocuments(invoices, details, payment_reason_codes) {
  return Object.keys(invoices).map((key) => {
    return mapInvoiceToPaymentDocument(invoices[key], details[key], payment_reason_codes);
  });
}

export function mapPaymentDetails(payment_card, cvv = '', address = {}) {
  const paymentMethod = payment_card.payment_card_type === 'EC' ? 'EC' : 'CC';
  return {
    payment_method: paymentMethod,
    payment_card_type: payment_card.payment_card_type,
    payment_card_token: payment_card.payment_card_token,
    payment_card_name: payment_card.payment_card_name,
    electronic_check_account_type: payment_card.electronic_check_account_type,
    electronic_check_rdfi_number: payment_card.electronic_check_rdfi_number,
    valid_to: payment_card.valid_to,
    card_validation_code: cvv,
    address_data: {
      name: getValue(address.name, ''),
      name_2: getValue(address.name_2, ''),
      city: getValue(address.city, ''),
      district: getValue(address.district, ''),
      street: getValue(address.street, ''),
      postal_code_city: getValue(address.postal_code_city, ''),
      region: getValue(address.region, ''),
      country: getValue(address.country, ''),
    }
  };
}

export function createPayerData(customerNumber, companyCode) {
  return new PayerData(customerNumber, companyCode);
}

export function mapDepositDetails(values){
  return {
        amount_to_process: values.amount_to_process,
        currency_key: 'USD',
        reason_code: values.reason_code,
        reference_number: values.reference_number,
        comment: values.comment
  }
}
